import axios, {AxiosInstance} from "axios";

const rest = axios.create(
    {
        baseURL: "/",
        timeout: 60000
    }
)

export function getAxios(): AxiosInstance {
    return rest;
}